import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, NavLink, Outlet } from "react-router-dom";

import {
  BsFillChatLeftTextFill,
  BsBellSlashFill,
  BsPersonXFill,
} from "react-icons/bs";
import { BsPinAngle } from "react-icons/bs";
import { FiFolder } from "react-icons/fi";
import { GoIssueOpened } from "react-icons/go";

import st from "./serverone.module.css";
import Messages from "./Messages/Messages";
import BottomServer from "./BottomServer/BottomServer";
import Members from "./Members/Members";

const ServerOne = () => {
  const [hideMembers, setHideMembers] = useState(true);
  const links = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];

  return (
    <section className={st.server_section}>
      <div className={st.users_container}>
        {/*--------------- Start channels---------------------- */}
        <div className={st.channels}>
          <Dropdown>
            <Dropdown.Toggle
              className={st.dropdown_toggle}
              variant=""
              id="dropdown-basic"
            >
              Channel Name
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
              <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
              <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className={st.channels_links}>
            {links.map((link, i) => (
              <NavLink to={"/user/server1/firstlink"} key={i}>
                <span className={st.white_circl}></span>
                <span># Link {i + 1}</span>
              </NavLink>
            ))}
          </div>
        </div>

        {/*------------------------------ End channels------------------------ */}

        {/*------------------------------ Start Server Users------------------------ */}
        <div className={st.server_user_container}>
          {/*------------------------------ Start Header server------------------------ */}
          <div className={st.header_server}>
            <h4 className="text-white"># Channel Name</h4>
            <div className={st.header_server_btns}>
              <button className={st.threads}>
                <span>#</span>
                <BsFillChatLeftTextFill className={st.theads_icon} />
              </button>
              <button className={st.notification_icon}>
                <BsBellSlashFill />
              </button>
              <button className={st.bin_icon}>
                <BsPinAngle />
              </button>
              <button
                onClick={() => setHideMembers(!hideMembers)}
                className={st.hide_members}
              >
                <BsPersonXFill />
              </button>
              <span className={st.header_server_input}>
                <input type="text" />
              </span>
              <button className={st.header_server_inbox}>
                <FiFolder />
              </button>
              <button className={st.header_server_help}>
                <GoIssueOpened />
              </button>
            </div>
          </div>
          {/*------------------------------ End Header server------------------------ */}

          <div className={st.user_activites}>
            <div className={st.messages}>
              <Outlet />
            </div>
            {hideMembers && (
              <div className={st.members}>
                <Members />
              </div>
            )}
          </div>
          <div className={st.bottom_server}>
            <BottomServer />
          </div>
        </div>
        {/*------------------------------ End Server Users------------------------ */}
      </div>
    </section>
  );
};

export default ServerOne;
